module.exports = __webpack_public_path__ + "img/map_bg.c5435332.png";